import { jsx as t, jsxs as u } from "react/jsx-runtime";
import { Menu as n } from "@base-ui/react/menu";
import { cn as d } from "../../lib/utils.js";
import { ChevronRightIcon as p, CheckIcon as c } from "lucide-react";
function h({ ...e }) {
  return /* @__PURE__ */ t(n.Root, { "data-slot": "dropdown-menu", ...e });
}
function w({ ...e }) {
  return /* @__PURE__ */ t(n.Portal, { "data-slot": "dropdown-menu-portal", ...e });
}
function b({ ...e }) {
  return /* @__PURE__ */ t(n.Trigger, { "data-slot": "dropdown-menu-trigger", ...e });
}
function m({
  align: e = "start",
  alignOffset: o = 0,
  side: a = "bottom",
  sideOffset: r = 4,
  anchor: i,
  className: s,
  ...l
}) {
  return /* @__PURE__ */ t(n.Portal, { children: /* @__PURE__ */ t(
    n.Positioner,
    {
      className: "isolate z-50 outline-none",
      align: e,
      alignOffset: o,
      side: a,
      sideOffset: r,
      anchor: i,
      children: /* @__PURE__ */ t(
        n.Popup,
        {
          "data-slot": "dropdown-menu-content",
          className: d("z-50 max-h-(--available-height) w-(--anchor-width) min-w-32 origin-(--transform-origin) overflow-x-hidden overflow-y-auto rounded-lg bg-popover p-1 text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 outline-none data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:overflow-hidden data-closed:fade-out-0 data-closed:zoom-out-95", s),
          ...l
        }
      )
    }
  ) });
}
function M({ ...e }) {
  return /* @__PURE__ */ t(n.Group, { "data-slot": "dropdown-menu-group", ...e });
}
function D({
  className: e,
  inset: o,
  ...a
}) {
  return /* @__PURE__ */ t(
    n.GroupLabel,
    {
      "data-slot": "dropdown-menu-label",
      "data-inset": o,
      className: d(
        "px-1.5 py-1 text-xs font-medium text-muted-foreground data-inset:pl-7",
        e
      ),
      ...a
    }
  );
}
function z({
  className: e,
  inset: o,
  variant: a = "default",
  ...r
}) {
  return /* @__PURE__ */ t(
    n.Item,
    {
      "data-slot": "dropdown-menu-item",
      "data-inset": o,
      "data-variant": a,
      className: d(
        "group/dropdown-menu-item relative flex cursor-default items-center gap-1.5 rounded-md px-1.5 py-1 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-7 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 data-[variant=destructive]:*:[svg]:text-destructive",
        e
      ),
      ...r
    }
  );
}
function N({ ...e }) {
  return /* @__PURE__ */ t(n.SubmenuRoot, { "data-slot": "dropdown-menu-sub", ...e });
}
function k({
  className: e,
  inset: o,
  children: a,
  ...r
}) {
  return /* @__PURE__ */ u(
    n.SubmenuTrigger,
    {
      "data-slot": "dropdown-menu-sub-trigger",
      "data-inset": o,
      className: d(
        "flex cursor-default items-center gap-1.5 rounded-md px-1.5 py-1 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-7 data-popup-open:bg-accent data-popup-open:text-accent-foreground data-open:bg-accent data-open:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...r,
      children: [
        a,
        /* @__PURE__ */ t(p, { className: "ml-auto" })
      ]
    }
  );
}
function y({
  align: e = "start",
  alignOffset: o = -3,
  side: a = "right",
  sideOffset: r = 0,
  className: i,
  ...s
}) {
  return /* @__PURE__ */ t(
    m,
    {
      "data-slot": "dropdown-menu-sub-content",
      className: d("w-auto min-w-[96px] rounded-lg bg-popover p-1 text-popover-foreground shadow-lg ring-1 ring-foreground/10 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", i),
      align: e,
      alignOffset: o,
      side: a,
      sideOffset: r,
      ...s
    }
  );
}
function I({
  className: e,
  children: o,
  checked: a,
  inset: r,
  ...i
}) {
  return /* @__PURE__ */ u(
    n.CheckboxItem,
    {
      "data-slot": "dropdown-menu-checkbox-item",
      "data-inset": r,
      className: d(
        "relative flex cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground data-inset:pl-7 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: a,
      ...i,
      children: [
        /* @__PURE__ */ t(
          "span",
          {
            className: "pointer-events-none absolute right-2 flex items-center justify-center",
            "data-slot": "dropdown-menu-checkbox-item-indicator",
            children: /* @__PURE__ */ t(n.CheckboxItemIndicator, { children: /* @__PURE__ */ t(
              c,
              {}
            ) })
          }
        ),
        o
      ]
    }
  );
}
function _({ ...e }) {
  return /* @__PURE__ */ t(
    n.RadioGroup,
    {
      "data-slot": "dropdown-menu-radio-group",
      ...e
    }
  );
}
function R({
  className: e,
  children: o,
  inset: a,
  ...r
}) {
  return /* @__PURE__ */ u(
    n.RadioItem,
    {
      "data-slot": "dropdown-menu-radio-item",
      "data-inset": a,
      className: d(
        "relative flex cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground data-inset:pl-7 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...r,
      children: [
        /* @__PURE__ */ t(
          "span",
          {
            className: "pointer-events-none absolute right-2 flex items-center justify-center",
            "data-slot": "dropdown-menu-radio-item-indicator",
            children: /* @__PURE__ */ t(n.RadioItemIndicator, { children: /* @__PURE__ */ t(
              c,
              {}
            ) })
          }
        ),
        o
      ]
    }
  );
}
function S({
  className: e,
  ...o
}) {
  return /* @__PURE__ */ t(
    n.Separator,
    {
      "data-slot": "dropdown-menu-separator",
      className: d("-mx-1 my-1 h-px bg-border", e),
      ...o
    }
  );
}
function C({
  className: e,
  ...o
}) {
  return /* @__PURE__ */ t(
    "span",
    {
      "data-slot": "dropdown-menu-shortcut",
      className: d(
        "ml-auto text-xs tracking-widest text-muted-foreground group-focus/dropdown-menu-item:text-accent-foreground",
        e
      ),
      ...o
    }
  );
}
export {
  h as DropdownMenu,
  I as DropdownMenuCheckboxItem,
  m as DropdownMenuContent,
  M as DropdownMenuGroup,
  z as DropdownMenuItem,
  D as DropdownMenuLabel,
  w as DropdownMenuPortal,
  _ as DropdownMenuRadioGroup,
  R as DropdownMenuRadioItem,
  S as DropdownMenuSeparator,
  C as DropdownMenuShortcut,
  N as DropdownMenuSub,
  y as DropdownMenuSubContent,
  k as DropdownMenuSubTrigger,
  b as DropdownMenuTrigger
};
//# sourceMappingURL=dropdown-menu.js.map
